import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/smile-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM332 312.6c8.5-10.2 23.6-11.5 33.8-3.1 10.2 8.5 11.6 23.6 3.1 33.8-30 36-74.1 56.6-120.9 56.6s-90.9-20.6-120.9-56.6c-8.4-10.2-7.1-25.3 3.1-33.8 10.2-8.4 25.3-7.1 33.8 3.1 20.8 25.1 51.5 39.4 84 39.4s63.2-14.4 84-39.4zM136.5 211l-9.5 17c-1.9 3.2-5.9 4.8-9.3 3.7-3.6-1.1-6-4.6-5.7-8.3 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c0.3 3.8-2.1 7.2-5.7 8.3-3.1 1-7.2 0-9.3-3.7l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6zM328 152c23.8 0 52.7 29.3 56 71.4 0.3 3.8-2.1 7.2-5.7 8.3-3.1 1-7.2 0-9.3-3.7l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-1.9 3.2-5.8 4.8-9.3 3.7-3.6-1.1-6-4.6-5.7-8.3 3.3-42.1 32.2-71.4 56-71.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/smile-beam.js
// module id = 1815
// module chunks = 0